import { createTheme } from '@mui/material/styles';
import { blue } from '@mui/material/colors';

const theme = createTheme({
    palette: {
        primary: {
            main: blue[700]
        },
        info: {
            main: "#5bc0de",
            light: "#46b8da",
            dark: "#00a5d6",
        }
    },
    typography: {
        "fontFamily": "Prompt",
        "fontSize": 14,
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                ".MuiDataGrid-main": {
                    // backgroundColor: orange[700],
                    // backgroundColor: "#d6d6d64d"
                },
                ".MuiDataGrid-menuIcon":
                {
                    ".MuiButtonBase-root": {
                        "svg": {
                            color: "white !important",
                        }
                    }
                },

                ".MuiDataGrid-columnHeaders": {
                    backgroundColor: '#a07300',
                    display: "flex"
                },
                ".MuiDataGrid-row.Mui-selected": {
                    backgroundColor: "#bfd4ff3b !important",
                    // color:"white",
                    ".MuiCheckbox-root": {
                        color: "#002484!important",
                    }
                },
                ".MuiDataGrid-columnHeaderTitle": {
                    color: "white !important",
                },
                ".MuiDataGrid-columnHeaderTitleContainer": {
                    ".MuiCheckbox-root": {
                        color: "white !important",
                        ".MuiCheckbox-root > Mui-checked": {
                            color: "white !important",
                        },
                    },
                    ".MuiDataGrid-iconButtonContainer": {
                        ".MuiButtonBase-root": {
                            "svg": {
                                color: "white !important",
                            }
                        }
                    }
                },
                ".MuiDataGrid-columnSeparator": {
                    display: "flex",
                    height: "100%",
                    ".MuiDivider-root": {
                        height: "100%",
                        margin: "0 10px",
                        borderColor: "white",
                        opacity: '0 !important',
                    }
                },
                ".MuiDataGrid-columnHeader, .MuiDataGrid-columnHeader--alignCenter, .MuiDataGrid-columnHeader--sortable": {
                    backgroundColor: '#a07300',
                    border: `1px solid rgba(224, 224, 224, 1)`
                },

                ".MuiDataGrid-root.show-line": {
                    ".MuiDataGrid-row": {
                        ".MuiDataGrid-cell": {
                            position: "relative",
                            "::after": {
                                position: "absolute",
                                content: '""',
                                height: "100%",
                                width: "1px",
                                backgroundColor: "rgba(96, 96, 96, 0.12)",
                                right: "-2px"
                            }
                        }
                    },
                },
                ".MuiDataGrid-footerContainer": {
                    overflow: "auto"
                },
                ".MuiDataGrid-row": {
                    backgroundColor: "#fff",
                    "& .MuiCheckbox-root.Mui-disabled": {
                        // color: "#d9d9d9 !important",
                        display: 'none',
                    },
                    "&:hover": {
                        backgroundColor: "#fff !important",
                        fontWeight: "bold",
                        // border: ".2px solid black",
                        color: "#393939",
                        ".MuiCheckbox-root": {
                            color: "#002484 !important",  
                        },
                        "& .MuiCheckbox-root.Mui-disabled": {
                            color: "#d9d9d9 !important",
                        },
                    },
                    "&:nth-of-type(even)": {
                        background: "#f6f6f6",
                        "&:hover": {
                            backgroundColor: "#f6f6f6 !important",
                        },
                    },
                },
                // ".MuiDataGrid-virtualScrollerRenderZone": {
                //     width: "100%",
                //     overflow: "hidden!important"
                // },
                // ".MuiDataGrid-virtualScroller": {
                //     overflow: "auto!important"
                // },

                // "@media only screen and (max-width:600px)": {
                //     ".MuiDataGrid-virtualScrollerContent": {
                //         width: "auto !important"
                //     },
                //     ".MuiDataGrid-columnHeaders": {
                //         display: "none !important"
                //     },
                //     ".MuiDataGrid-virtualScroller": {
                //         marginTop: "0px !important",
                //         overflow: "hidden!important"
                //     },


                //     ".MuiDataGrid-row": {
                //         borderBottom: "1px solid #f0f0f0",
                //         counterReset: "n",
                //         position: "relative",
                //         flexDirection: "column !important",
                //         width: "100% !important",
                //         ".MuiDataGrid-cell": {
                //             borderBottom: "none !important",
                //             maxWidth: "none !important",
                //             width: "100%",
                //             justifyContent: "start !important",
                //             alignItems: "start !important",
                //             "::before": {
                //                 content: 'attr(data-columnname)',
                //                 width: "5em",
                //                 overflowWrap: "break-word"
                //             }
                //         },
                //         ".MuiDataGrid-cell:not([data-columnname])": {
                //             counterIncrement: "n",
                //             position: "absolute",
                //             width: "40px",
                //             height: "40px",
                //             minWidth: "0 !important",
                //             bottom: 10,
                //             ".MuiButtonBase-root": {
                //                 width: "30px",
                //                 height: "30px",
                //                 minHeight: 0,
                //                 "svg": {
                //                     fontSize: "18px"
                //                 }
                //             }
                //         },
                //         ".MuiDataGrid-cell.checkbox-actions": {
                //             position: "absolute",
                //             width: "10px",
                //             height: "10px",
                //             minWidth: "0 !important",
                //             top: -5,
                //             left: -12,
                //         },
                //         ".cell-actions-0": {
                //             right: "5px"
                //         },
                //         ".cell-actions-1": {
                //             right: "55px"
                //         },
                //         ".cell-actions-2": {
                //             right: "105px"
                //         },
                //         ".cell-actions-3": {
                //             right: "155px"
                //         },
                //         ".cell-actions-4": {
                //             right: "205px"
                //         },

                //         ".head-cell.MuiDataGrid-cell::before": {
                //             fontWeight: "bold",
                //         },
                //         ".head-cell.MuiDataGrid-cell>div": {
                //             fontWeight: "bold"
                //         }
                //     },

                //     ".MuiDataGrid-row:has(.MuiDataGrid-cell:not([data-columnname]):not(.checkbox-actions))": {
                //         paddingBottom: "4em"
                //     },
                //     ".MuiDataGrid-row:has(.MuiDataGrid-cell.checkbox-actions)": {
                //         paddingLeft: "1.2em"
                //     }
                // },

                "label.MuiInputLabel-shrink": {
                    color: "#060606",
                    top: "0px",
                },
                ".MuiInputLabel-outlined": {
                    top: "0px",     //Recheck
                },
                ".MuiFormHelperText-root": {
                    margin: '3px 0 0 !important',
                },
                "& .MuiInputBase-root.Mui-disabled": {
                    backgroundColor: '#f2f1f1 !important',
                    color: '#4a4a4a !important',
                },
                "& .MuiFormLabel-root-MuiInputLabel-root.Mui-disabled": {
                    color: 'rgb(52 52 52) !important',
                },
                "& .MuiInputBase-input-MuiOutlinedInput-input:disabled": {
                    backgroundColor: '#f2f1f1 !important',
                    color: '#4a4a4a !important',
                    boxShadow: 'none',
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: "10px",
                    boxShadow: "rgba(116, 116, 116, 0.189) 0px 5px 15px",
                },
                input: {
                    color: '#363636',
                    backgroundColor: "rgba(255,255,255,0.95)",
                    borderRadius: "10px",
                    // padding: "9px 10px",
                    ":disabled": {
                        backgroundColor: '#f2f1f1 !important',
                        color: '#4a4a4a !important',
                        boxShadow: 'none',
                    }
                },
                multiline: {
                    backgroundColor: "rgba(255,255,255,0.95)",
                    padding: 0,
                    input: {
                        padding: "4px",
                    },
                    ":disabled": {
                        backgroundColor: '#f2f1f1 !important',
                        color: '#4a4a4a !important',
                        boxShadow: 'none',
                    }
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    borderRadius: "10px",
                    backgroundColor: "rgba(255,255,255,0.95)",
                },
                input: {
                    color: '#363636',
                    backgroundColor: "rgba(255,255,255,0.95)",
                    borderRadius: "10px",

                    ":disabled": {
                        backgroundColor: '#f2f1f1 !important',
                        color: '#4a4a4a !important',
                        boxShadow: 'none',
                    }
                }
            }
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    borderRadius: "20px",
                    backgroundColor: "rgba(255,255,255,0.95)",
                },
            }
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    zIndex: 1,
                },
            }
        },
        MuiSelect: {
            styleOverrides: {
                outlined: {
                    backgroundColor: "transparent",
                },
            }
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    '&.Mui-disabled': {
                        color: "#000000 !important",
                    },
                },
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: "#000000",
                    },
                },
                shrink: {
                    top: "0px",
                    // backgroundColor: '#e9e6e6',
                }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: "rgba(0, 0, 0, 0.6) !important",
                },
                asterisk: {
                    color: "red"
                }
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    color: "#d32f2f",
                    fontWeight: 400,
                    fontSize: ".85rem"
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    width: "42px",
                    height: "42px"
                }
            }
        },
        MuiDialog :{
            styleOverrides: {
                root: {
                    zIndex: 1700,
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    marginTop: "0px",
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: "41px",
                },
            },
        },
        MuiBreadcrumbs: {
            styleOverrides: {
                separator: {
                    color: "white"
                }
            }
        },
        MuiFab: {
            styleOverrides: {
                root: {
                    fontSize: "1.2rem",
                },
            }
        },
        MuiTooltip: {
            styleOverrides: {
                popper: {
                    zIndex: 9999,
                },
            },
        }
    }
});

export default theme;